<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="note"><span class="epub-b">Author Note</span></p>
<p class="fmtni">In my last novel, <span class="epub-i">Once Upon A Scandal,</span> an excerpt from this book appeared under the title of <span class="epub-i">The Venus Touch.</span> I wanted you to know that <span class="epub-i">Her Secret Affair</span> is that very same book; only the title has been changed. Enjoy!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// note.vue?706d6fd2